export default "__VITE_ASSET__261c863e__"